"use strict";

const { default: axios } = require("axios");
const { default: UtilitiesUP } = require("../components/utilities");
const { default: Loader } = require("../components/Loader.js");
const { conforms } = require("lodash");

const Teto = function () {

    const addProductProposal = function () {
        const el = $(this);
        const elParent = el.closest('tr');
        const id = el.data('id');

        const row = el.closest('#item_' + id);
        const url = el.data('ajax');

        const color = row.find('.color').val();
        const qtd = row.find('.qtd').val();
        const price = el.data('price');

        const min = Number(row.find('.qtd').attr('min'));
        const max = Number(row.find('.qtd').attr('max'));

        const classUtilitites = new UtilitiesUP;

        if (qtd <= 0) {
            classUtilitites.showAlert('A quantidade não pode ser zero', "ERRO", "error");
            return false;
        }

        if (color.length === 0) {
            classUtilitites.showAlert('A cor é um dado obrigatório', "ERRO", "error");
            return false;
        }

        if (qtd >= min && qtd <= max) {

            // el.addClass('d-none');
            // el.after('<div class="spinner"></div>');

            $('html').css('overflow', 'hidden');

            Loader.wrap(axios.post(url, {
                'product_id': id,
                'product_qty': qtd,
                'product_price': price,
                'color': color
            })).then(function (response) {
                const data = response.data;

                if (data.error == false) {
                    elParent.find('.select-plugin').val("");
                    elParent.find('.qtd').val(0);

                    // classUtilitites.showAlert(data.message, "Ok", "success");
                    classUtilitites.switchReturns(data);
                } else {
                    classUtilitites.showAlert(data.message, "Ok", "error");
                }
            })
            .catch((error) => classUtilitites.showCommunicationError(error))
            .finally(() => $('html').css('overflow', 'auto'));
        } else {
            classUtilitites.showAlert('A quantidade está fora do padrão aceito', "ERRO", "error");
            return false;
        }
    }

    const productAll = function () {
        let el = $('#product-all');
        let url = el.data('url');

        axios.post(url)
            .then(function (response) {
                let data = response.data;
                if (data.error == false) {
                    let result = data.result;

                    el.find('.qtde_prod').html(result.qtde_prod);
                    el.find('.qtde_comp').html(result.qtde_comp);
                    el.find('.valor_total').html(result.valor_total);
                    el.find('.valor_custo').html(result.valor_custo);
                    el.find('.qtde_prod_general').html(result.general.qtde_prod);
                    el.find('.qtde_comp_general').html(result.general.qtde_comp);
                }
            });
    }

    const pvOne = function () {
        let el = $('#pv-one');
        let url = el.data('url');

        axios.post(url)
            .then(function (response) {
                let data = response.data;
                if (data.error == false) {
                    let result = data.result;

                    for (const [key, value] of Object.entries(result)) {
                        let el = $('#product-' + value.produto_virtual);

                        el.find('.qtd').html(value.qtde_comp);
                        el.find('.total').html(value.valor_total);
                    }

                }
            });
    }

    const pvMillennium = function () {
        let el = $('#pv-millennium');
        let url = el.data('url');

        $('tr.product').hide();

        axios.post(url)
            .then(function (response) {
                let data = response.data;
                if (data.error == false) {
                    let result = data.result;

                    for (const [key, value] of Object.entries(result)) {
                        let el = $('#product-' + value.produto_virtual);

                        el.find('.qtd').html(value.qtde_comp);
                        el.find('.total').html(value.valor_total);

                        el.removeClass('remove');
                    }

                    $('tr.product.remove').remove();
                    $('tr.product').show();
                }
            });
    }

    const colorsMillennium = function () {
        let el = $('#colors-millennium');
        let url = el.data('url');

        axios.post(url)
            .then(function (response) {
                let data = response.data;
                if (data.error == false) {
                    let result = data.result;

                    $('#body-colors').html(result.html);
                }
            });
    }

    const sendAjaxOnload = function (el) {
        const href = el.data('ajax');

        axios.post(href)
            .then(function (response) {
                let data = response.data;

                el.html(data.total);
            });
    }

    const dontSubmit = function() {
        const el = $(this);
        el.on('keydown', function (e) {
            const key = e.key || e.keyCode;
            if (key === 'Enter' || key === 13) {
                e.preventDefault();
            }
        });
    }

    const checkDocument = function () {
        const el = $(this);
        const url = el.data('url');
        const document = el.val();

        if (document.length == 0) {
            return false;
        }

        let spinner = el.closest('.spinner-check-document');
        spinner.removeClass('spinner-none').addClass('spinner');

        axios.post(url, {
            'document': document
        }).then(function (response) {
            const data = response.data;
            const result = data.result;

            if (data.error == false && result.total > 0) {
                $('.response-check-document').html(result.html);
            }

            spinner.addClass('spinner-none').removeClass('spinner');
        });
    }

    const removeProductCatalog = function(){
        const el = $(this);
        const id = el.data('id');

        $('.product-catalog#product-' + id).remove();
    }

    return {
        init: function () {
            $(document).on('click', '.add-product-proposal', addProductProposal);
            $(document).on('keyup', '.check-document', checkDocument);
            $(document).on('keydown', '.check-document', dontSubmit);
            $(document).on('click', '.remove-product-catalog', removeProductCatalog);
            

            if ($('#product-all').length > 0) {
                productAll();
            }

            if ($('#pv-one').length > 0) {
                pvOne();
            }

            if ($('#pv-millennium').length > 0) {
                pvMillennium();
            }

            if ($('#colors-millennium').length > 0) {
                colorsMillennium();
            }

            if ($('.send-ajax-onload').length > 0) {
                $('.send-ajax-onload').each(function () {
                    sendAjaxOnload($(this))
                });
            }

            if ($('.load-element-ajax').length > 0) {
                let data = [];

                $('.load-element-ajax').each(function () {
                    let el = $(this);

                    let elType = el.data('type');
                    let elId = el.data('id');
                    let elOptions = el.data('options');

                    data.push({
                        'type': elType,
                        'id': elId,
                        'options': elOptions
                    });
                });

                axios.post($('#load-element-ajax').val(), data)
                    .then(function (response) {
                        let data = response.data;

                        if (data.error == false) {
                            data = data.result;
                            console.log(data.html);

                            Object.entries(data.html).forEach(([type, values]) => {
                                Object.entries(values).forEach(([id, item]) => {
                                    $('.load-element-ajax[data-type="' + type + '"][data-id="' + id + '"] .response').html(item);
                                });    
                            });

                        }
                    });
            }
        }
    }

}();

module.exports = Teto;